'use client';

import { datadogRum } from '@datadog/browser-rum';
import packageJson from 'package.json';
import type { PropsWithChildren } from 'react';

import { isServer } from '@/constants/common';

if (!isServer && process.env.NODE_ENV === 'production') {
	datadogRum.init({
		applicationId: process.env.NEXT_PUBLIC_DATA_DOG_APPLICATION_ID as string,
		clientToken: process.env.NEXT_PUBLIC_DATA_DOG_CLIENT_TOKEN as string,
		site: 'datadoghq.eu',
		service: process.env.NEXT_PUBLIC_DATA_DOG_SERVICE as string,
		env: process.env.NEXT_PUBLIC_DATA_DOG_ENV as string,
		// Specify a version number to identify the deployed version of your application in Datadog
		version: packageJson.version,
		sessionSampleRate: 10,
		sessionReplaySampleRate: 50,
		trackUserInteractions: true,
		trackResources: true,
		trackLongTasks: true,
		defaultPrivacyLevel: 'mask-user-input',
	});
	datadogRum.startSessionReplayRecording();
}

export default function DatadogInitializer({ children }: PropsWithChildren) {
	return children;
}
